import { Box, Paper, Typography } from '@mui/material';
import startCase from 'lodash/startCase';
import dayjs from 'dayjs';

import DocumentTextIcon from '../../Icons/DocumentTextIcon';

import DocumentItemActions from './DocumentItemActions';

import DocumentCheckIcon from 'modules/common/components/Icons/DocumentCheckIcon';
import { Document } from 'modules/common/interfaces/documents';
import { grey, white } from 'theme/colors';

const DocumentItem = ({ document, disabled }: { document: Document; disabled?: boolean }) => {
    // Style for the Paper element
    const paperStyle = {
        borderColor: grey[50],
        backgroundColor: !document.source ? grey[50] : white,
        display: 'inline-flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '8px 16px',
        marginBottom: '8px',
    };

    // Renders the DocumentCheckIcon if the document has a source, else it renders the DocumentTextIcon
    const icon = document.source ? (
        <DocumentCheckIcon data-testid="check-icon" />
    ) : (
        <DocumentTextIcon data-testid="text-icon" />
    );

    return (
        <Paper sx={paperStyle} variant="outlined" aria-label="Document item" data-testid="file-segment">
            <Box sx={{ display: 'inline-flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ mr: 1 }}>{icon}</Box> {/* The icon element */}
                <div>
                    {/* Document name */}
                    <Typography aria-label="Document name" variant="body2">
                        {document.file_name ?? startCase((document.document_type ?? '').toLowerCase())}
                    </Typography>
                    {/* Uploaded date */}
                    <Typography aria-label="Uploaded date" variant="subtitle2">
                        Uploaded at {dayjs(document.created_at).format('MM-DD-YYYY')}
                    </Typography>
                </div>
            </Box>
            {/* DocumentItemActions for the document */}
            <DocumentItemActions document={document} disabled={disabled} />
        </Paper>
    );
};

export default DocumentItem;
